"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var client_lib_js_player_addons_common_player_1 = require("@sky-uk-ott/client-lib-js-player-addons-common-player");
var DeviceRecognition = (function () {
    function DeviceRecognition() {
    }
    DeviceRecognition.getCurrentDeviceType = function (context) {
        var window = context;
        var userAgent = window && window.navigator && window.navigator.userAgent && window.navigator.userAgent.toLowerCase();
        if (window.deviceTypeId && window.deviceTypeId === 'shaka') {
            return client_lib_js_player_addons_common_player_1.DeviceType.Shaka;
        }
        if (userAgent && userAgent.indexOf('crkey') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.Chromecast;
        }
        if (userAgent && userAgent.indexOf('playstation 3') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.PS3;
        }
        if (userAgent && userAgent.indexOf('playstation 4') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.PS4;
        }
        if (userAgent && userAgent.indexOf('netcast') !== -1 && !window.PalmSystem) {
            return client_lib_js_player_addons_common_player_1.DeviceType.NetCast;
        }
        if (userAgent && userAgent.indexOf('web0s') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.WebOS;
        }
        if (window && window.hasOwnProperty('tizen') && window.tizen) {
            return client_lib_js_player_addons_common_player_1.DeviceType.Tizen;
        }
        if (userAgent && userAgent.indexOf('youviewhtml') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.YouView;
        }
        if (userAgent && userAgent.indexOf('android') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.Android;
        }
        if (userAgent && userAgent.indexOf('msapphost') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.XboxOne;
        }
        if (userAgent && userAgent.indexOf('netbox') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.EETV;
        }
        if (userAgent && userAgent.indexOf('electron') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.Videoguard;
        }
        if (userAgent && userAgent.indexOf('roku') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.Roku;
        }
        if (userAgent && userAgent.indexOf('vodafone_stb') !== -1) {
            return client_lib_js_player_addons_common_player_1.DeviceType.Vodafone;
        }
        return client_lib_js_player_addons_common_player_1.DeviceType.Browser;
    };
    return DeviceRecognition;
}());
exports.DeviceRecognition = DeviceRecognition;
